import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import "../../../assets/css/admin/allAdmins.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import { useAuth } from "../../../AuthContext";
import { useSidebar } from "../../../context/SidebarContext";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { toast } from "react-toastify";
import swal from "sweetalert";
import api from "../../../api";

const AllQuestionsTopicwise = () => {
  const { user, logout } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const [questions, setQuestions] = useState([]);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [topics, setTopics] = useState([]);

  const [loading, setLoading] = useState(false);

  const [totalPages, setTotalPages] = useState(1);

  const [filters, setFilters] = useState(() => {
    const defaultFilters = {
      subject: "",
      topic: "",
      difficulty: "",
      search: "",
      page: 1,
      limit: 10,
    };
    const saved = localStorage.getItem("topicwiseQuestionsFilters");
    return saved ? { ...defaultFilters, ...JSON.parse(saved) } : defaultFilters;
  });

  const { subject, topic, difficulty, search, page, limit } = filters;

  const [searchInput, setSearchInput] = useState(search);
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  // 🔹 Fetch Topics
  const getTopics = async () => {
    if (!subject) return;
    try {
      const res = await axios.get(
        `${baseUrl}/topic/by-subject?subject=${subject}`
      );
      setTopics(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // 🔹 Fetch Questions
  const getQuestions = async () => {
    if (!subject || !topic) return;

    setLoading(true);
    try {
      const params = new URLSearchParams({
        subject,
        topic,
        difficulty,
        search,
        page,
        limit,
      });

      const res = await axios.get(`${baseUrl}/question/all/topicwise?${params.toString()}`);

      setQuestions(res.data.questions);
      setTotalQuestions(res.data.total);
      setTotalPages(res.data.totalPages);
    } catch (err) {
      console.log(err);
      toast.error("Error fetching questions");
    }
    setLoading(false);
  };

  // 🔹 Delete
  const deleteQuestion = (q) => {
    swal({
      title: "Are you sure?",
      text: "This question will be permanently deleted!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        api
          .post(`${baseUrl}/question/delete/?id=${q._id}`)
          .then((res) => {
            toast.success(res.data.message);
            getQuestions();
          })
          .catch(() => toast.error("Delete failed"));
      }
    });
  };

  // 🔹 Effects
useEffect(() => {
  if (!subject) return;
  getTopics();
}, [subject]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      page: 1,
    }));
  }, [topic, difficulty, search]);

  useEffect(() => {
    getQuestions();
  }, [subject, topic, difficulty, search, page, limit]);

  // 🔹 Checkbox
  const handleCheck = (id) => {
    setSelectedQuestions((prev) =>
      prev.includes(id)
        ? prev.filter((q) => q !== id)
        : [...prev, id]
    );
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setFilters((prev) => ({
      ...prev,
      search: searchInput.trim(),
      page: 1,
    }));
  };

  const clearSearch = () => {
    setSearchInput("");
    setFilters((prev) => ({
      ...prev,
      search: "",
      page: 1,
    }));
  };

  useEffect(() => {
  localStorage.setItem(
    "topicwiseQuestionsFilters",
    JSON.stringify(filters)
  );
}, [filters]);

  return (
    <div className={`${styles.layout} ${!isSidebarOpen ? styles.sidebarClosed : ""}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? styles.open : styles.closed}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        {/* Toggle */}
        <div style={{ height: "30px" }} className="position-relative">
          {isSidebarOpen ? (
            <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />
          ) : (
            <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />
          )}
        </div>

        <div className="container-fluid bg-white p-4 shadow-sm rounded">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">📚 Topic-wise Questions</h4>
            <span className="text-muted">Total Selected: {selectedQuestions.length}</span>
          </div>

          {/* Filters */}
          <div className="row g-3 mb-4">
            <div className="col-md-3">
              <label className="form-label">Subject</label>
              <select className="form-select" value={subject}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    subject: e.target.value,
                    topic: "",
                    page: 1,
                  }))
                }
              >
                <option value="">Select Subject</option>
                <option value="Physics">Physics</option>
                <option value="Chemistry">Chemistry</option>
                <option value="Biology">Biology</option>
              </select>
            </div>

            <div className="col-md-3">
              <label className="form-label">Topic</label>
              <select
                className="form-select"
                value={topic}
                disabled={!subject}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    topic: e.target.value,
                  }))
                }
              >
                <option value="">Select Topic</option>
                {topics.map((t) => (
                  <option key={t._id} value={t._id}>
                    {t.topicName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <label className="form-label">Difficulty</label>
              <select className="form-select" value={difficulty}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    difficulty: e.target.value,
                  }))
                }
              >
                <option value="">All</option>
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </select>
            </div>

            <div className="col-md-2">
              <label className="form-label">Per Page</label>
              <select className="form-select" value={limit}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    limit: Number(e.target.value),
                  }))
                }
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label">Search Question</label>
              <form className="d-flex gap-2" onSubmit={handleSearchSubmit}>
                <input
                  className="form-control"
                  type="search"
                  placeholder="Question, option..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <button className="btn btn-primary" type="submit">
                  Search
                </button>
                {search && (
                  <button className="btn btn-outline-secondary" type="button" onClick={clearSearch}>
                    Clear
                  </button>
                )}
              </form>
            </div>
          </div>

          {/* Content */}
          {!topic ? (
            <div className="text-center text-muted py-5">
              👉 Please select a topic to view questions
            </div>
          ) : loading ? (
            <div className="text-center py-5">Loading...</div>
          ) : (
            <>
              <div className="mb-2 text-muted">
                Total Questions: {totalQuestions}
              </div>

              <div style={{ overflowX: "auto" }}>
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Question</th>
                      <th>Difficulty</th>
                      <th style={{ minWidth: "150px" }}>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {questions.map((q, i) => (
                      <tr key={q._id}>
                        <td>{(page - 1) * limit + i + 1}</td>

                        <td
                          style={{ maxWidth: "500px" }}
                          dangerouslySetInnerHTML={{ __html: q.question }}
                        />

                        <td>
                          <span className={`badge bg-${
                            q.difficulty === "easy"
                              ? "success"
                              : q.difficulty === "medium"
                              ? "warning"
                              : "danger"
                          }`}>
                            {q.difficulty}
                          </span>
                        </td>

                        {/* 🔥 Actions */}
                        <td>
                          <div className="d-flex gap-2">
                            <Link to={`/admin/question/view/${q._id}`}>
                              <button className="btn btn-sm btn-info">
                                <VisibilityIcon fontSize="small" />
                              </button>
                            </Link>

                            <Link to={`/admin/question/edit/${q._id}`}>
                              <button className="btn btn-sm btn-success">
                                <EditIcon fontSize="small" />
                              </button>
                            </Link>

                            <button
                              onClick={() => deleteQuestion(q)}
                              className="btn btn-sm btn-danger"
                            >
                              <DeleteOutlineIcon fontSize="small" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  disabled={page === 1}
                      onClick={() =>
                        setFilters((prev) => ({ ...prev, page: prev.page - 1 }))
                      }
                    >
                  Prev
                </button>

                <span className="fw-semibold">
                  Page {page} of {totalPages}
                </span>

                <button
                  className="btn btn-outline-secondary btn-sm"
                  disabled={page === totalPages}
                      onClick={() =>
                        setFilters((prev) => ({ ...prev, page: prev.page + 1 }))
                      }
                >
                  Next
                </button>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default AllQuestionsTopicwise;
